import { useState, useEffect } from 'react';
import { Table, Form, Button, InputGroup, Row, Col, Pagination } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getRoles } from '../utils/api';
import Header from './Header';
import Loader from './Loader';
import { faGavel, faPencil, faTrashCan, faX } from '@fortawesome/free-solid-svg-icons';
import ShowMenuButton from './ShowMenuButton';
import Error from './Error';
import { useDataStore } from '../Store';

const Roles = ({ itemSelected }) => {

    const selectedEntity = useDataStore((state) => state.selectedEntity);

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchText, setSearchText] = useState('');
    const [page, setPage] = useState(1);

    const fetchData = async () => {
        setLoading(true);
        const data = await getRoles(selectedEntity, page, 50, searchText);
        if (data) {
            setData(data);
        }
        else {
            setError('Failed to fetch data');
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, [searchText, page]);



    const rowClicked = (o) => {
        if (itemSelected) {
            itemSelected(o);
            return;
        }
    };
    const lastPage = data.LastPage;

    return (
        <div style={{ padding: 10 }}>
            {!itemSelected && <Header title='Roles' description="View roles" />}
            <Row className="mb-3">
                <Col md={12}>
                    <InputGroup>
                        <Form.Control
                            type="text"
                            placeholder="Search roles..."
                            value={searchText}
                            onChange={(e) => {
                                setPage(1);
                                setSearchText(e.target.value)
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    e.preventDefault();
                                    setPage(1);
                                    fetchData();
                                }
                            }}
                        />
                        <Button variant="outline-secondary" onClick={fetchData}>
                            Search
                        </Button>
                    </InputGroup>
                </Col>
            </Row>

            {loading ? <Loader /> : error ? <Error /> : (
                <>
                    <Row className="mb-3 mt-3">
                        <Col>
                            <div style={{ overflowX: 'auto', width: '100%' }}>
                                <Table striped bordered hover style={{ minHeight: 190, overflow: 'visible' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ whiteSpace: 'nowrap' }}>
                                                ID
                                            </th>
                                            <th style={{ whiteSpace: 'nowrap' }}>
                                                Name
                                            </th>
                                            <th style={{ whiteSpace: 'nowrap' }}>
                                                Description
                                            </th>
                                            {itemSelected && <th>Actions</th>}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data?.Results?.map((d, idx) => (
                                            <tr key={idx}>
                                                <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle', cursor: itemSelected ? 'pointer' : 'none' }} onClick={() => rowClicked(d)}>{d?.Id}</td>
                                                <td style={{ whiteSpace: 'nowrap', verticalAlign: 'middle', cursor: itemSelected ? 'pointer' : 'none' }} onClick={() => rowClicked(d)}>{d?.Name}</td>
                                                <td style={{ whiteSpace: 'normal', width: '100%', verticalAlign: 'middle', cursor: itemSelected ? 'pointer' : 'none' }} onClick={() => rowClicked(d)}>{d?.Description}</td>
                                                {itemSelected && <td style={{ whiteSpace: 'nowrap', textAlign: 'center', verticalAlign: 'middle' }}><Button onClick={() => itemSelected(d)}>Select</Button></td>}
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </Col>
                    </Row>

                    <Row className="mb-3 mt-3">
                        <Col className="d-flex justify-content-center">
                            <Pagination>
                                <Pagination.First disabled={page <= 1} onClick={() => setPage(1)} />
                                <Pagination.Prev disabled={page <= 1} onClick={() => setPage(page - 1)} />
                                <Pagination.Item key={page} active={true}>
                                    {page}
                                </Pagination.Item>
                                <Pagination.Next disabled={page >= lastPage} onClick={() => setPage(page + 1)} />
                                <Pagination.Last disabled={page >= lastPage} onClick={() => setPage(lastPage)} />
                            </Pagination>
                        </Col>
                    </Row>
                </>
            )}
        </div>
    );
};

export default Roles;
